"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TableCell_1 = require("@material-ui/core/TableCell");

var CheckBox_1 = require("@material-ui/icons/CheckBox");

var CheckBoxOutlineBlank_1 = require("@material-ui/icons/CheckBoxOutlineBlank");

var React = require("react");

var tubular_common_1 = require("tubular-common");

exports.renderCellContent = function (column, row) {
  switch (column.DataType) {
    case tubular_common_1.ColumnDataType.NUMERIC:
      return row[column.Name] || 0;

    case tubular_common_1.ColumnDataType.DATE:
      return tubular_common_1.formatDate(row[column.Name]);

    case tubular_common_1.ColumnDataType.DATE_TIME:
    case tubular_common_1.ColumnDataType.DATE_TIME_UTC:
      return tubular_common_1.formatDate(row[column.Name], 'M/d/yyyy h:mm a');

    case tubular_common_1.ColumnDataType.BOOLEAN:
      return row[column.Name] === true ? React.createElement(CheckBox_1["default"], null) : React.createElement(CheckBoxOutlineBlank_1["default"], null);

    default:
      return row[column.Name];
  }
};

exports.renderCells = function (columns, row) {
  return columns.filter(function (col) {
    return col.Visible;
  }).map(function (column) {
    return React.createElement(TableCell_1["default"], {
      key: column.Name,
      padding: column.Label === '' ? 'none' : 'default',
      align: tubular_common_1.getColumnAlign(column)
    }, exports.renderCellContent(column, row));
  });
};